/**
 * Web wrapper around @wg/api/itinerary — same client + same types as RN.
 */
import { createItineraryApi } from '@wg/api/itinerary';
import { httpClient } from '../http';
import logger from '../utils/logger';

const api = createItineraryApi(httpClient, logger);

export default api;
export const itineraryApi = api;
